/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Tut_Wakil_S2Inputs */

const en_tut_wakil_s2 = /** @type {(inputs: Tut_Wakil_S2Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Choose when it may answer: when you **receive a direct message**, are **mentioned in a channel**, or are **mentioned in an issue comment**.`)
};

const id_tut_wakil_s2 = /** @type {(inputs: Tut_Wakil_S2Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Pilih kapan ia boleh menjawab: saat Anda **menerima pesan langsung**, **di-mention di channel**, atau **di-mention di komentar issue**.`)
};

/**
* | output |
* | --- |
* | "Choose when it may answer: when you **receive a direct message**, are **mentioned in a channel**, or are **mentioned in an issue comment**." |
*
* @param {Tut_Wakil_S2Inputs} inputs
* @param {{ locale?: "en" | "id" }} options
* @returns {LocalizedString}
*/
export const tut_wakil_s2 = /** @type {((inputs?: Tut_Wakil_S2Inputs, options?: { locale?: "en" | "id" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Tut_Wakil_S2Inputs, { locale?: "en" | "id" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "id") return id_tut_wakil_s2(inputs)
	return en_tut_wakil_s2(inputs)
});